<div :class="[ 'routerPanel', 'leftPanel', showHamIcon ? 'open' : '', localStorageGet('FS-Impersonate') ? 'shiftPadding' : '', isNavBarOpen ? 'isNavBarOpen' : '' ]"
    v-if="user.authenticated && isValidNavigation && isValidPermissionArr()">
    <div class="navigation-header">
        <div :class="['logo', showHamIcon ? 'open' : '']">
            <!-- HamBurgerLogo -->
            <div :class="['mobileMenu', showHamIcon ? 'open' : '']" @click="changeHamIconStatus"
                v-if="user.authenticated && isValidNavigation">
                <span :class="'mobileMenuBar'"></span>
                <span :class="'mobileMenuBar'"></span>
                <span :class="'mobileMenuBar'"></span>
            </div>
            <!-- Support -->
            <!-- <div :class="'supportLink'" v-if="user.authenticated && isValidNavigation">
                <a :class="'supportLinkTitle'" :id="$vId(this, 'left-support')"
                    href='https://foundrysupport.monotype.com'
                    rel="noopener noreferrer" target='_blank'>
                    {{ $t('components.general.fou_navigation.support') }}
                </a>
            </div> -->
        </div>
    </div>
    <ArrowIcon @click="toggleNavBar" :class="['navBarArrowIcon', isNavBarOpen ? '': 'rotateNavIcon', localStorageGet('FS-Impersonate') ? 'shiftArrow' : '']"/>
    <div class="fou-sidenav-div">
        <div class="internalTagMobile" v-if="hasRole(['bulkIngestionUser'])">
            <RectangleTag>
              {{$t('components.general.fou_navigation.internal_tag')}}
            </RectangleTag>
        </div>
        <nav class="fou-sidenav" data-qa-id="fou-sidenav" v-if="isNavBarOpen || showHamIcon">
            <div>
                <div v-for="(sideNavTab, index) in sideNavArray" :key="sideNavTab.title">
                    <navigation-tab
                        v-if="sideNabChecks(sideNavTab)"
                        :sideNavTab="sideNavTab"
                        :index="index"
                        @update:sideNavTab="updateSideNavTab"
                        :showHamIcon="showHamIcon"
                    />
                </div>
            </div>
            <div class="sidenavBottom">
                <SideNavNudge
                    v-if="nudgeConfig"
                    :title="$t(nudgeConfig.title, nudgeConfig.titleParams || {})"
                    :showClose="nudgeConfig.showClose || false"
                    :bgColor="nudgeConfig.bgColor"
                    @close="dismissNudge"
                >
                    <template v-if="nudgeConfig.type === 'previouslyReleased'">
                        <p>{{ $t(nudgeConfig.description) }} <strong style="color: var(--md-color--absolutes--black)">{{ nudgeConfig.count }}</strong> {{ $t('components.general.side_nav_nudge.desc_previously_released_suffix') }}</p>
                    </template>
                    <template v-else>
                        <p>{{ $t(nudgeConfig.description) }}<template
                            v-if="nudgeConfig.linkInline && nudgeConfig.linkText"
                            ><a :href="$t(nudgeConfig.linkUrl)"
                                target="_blank"
                                rel="noopener noreferrer"
                                @click="handleNudgeContactSupportClick"
                        >{{ $t(nudgeConfig.linkText) }}</a></template></p>
                        <p v-if="!nudgeConfig.linkInline && nudgeConfig.linkText">
                            <template v-if="nudgeConfig.linkPrefix">{{ $t(nudgeConfig.linkPrefix) }}</template>
                            <a :href="$t(nudgeConfig.linkUrl)"
                               target="_blank"
                               rel="noopener noreferrer"
                            >{{ $t(nudgeConfig.linkText) }}</a>
                        </p>
                        <p v-if="nudgeConfig.contactAdmin">
                            {{ $t('components.general.side_nav_nudge.contact_admin') }}
                        </p>
                    </template>
                    <template v-if="nudgeConfig.showReviewCta" #actions>
                        <MdButton data-qa-id="nudge-review-inventory-btn" variant="ghost" color="blue" size="small" @click="handleNudgeReviewInventory">
                            {{ $t('components.general.side_nav_nudge.cta_review_inventory') }}
                        </MdButton>
                        <MdButton data-qa-id="nudge-rerelease-all-btn" color="blue" size="small" :disabled="isNudgeSubmitting" @click="handleNudgeReReleaseAll">
                            <AnimationProcessing v-if="isNudgeSubmitting" fill="white" :customStyle="true" class="nudge-btn-spinner" />
                            {{ $t('components.general.side_nav_nudge.cta_rerelease_all') }}
                        </MdButton>
                    </template>
                    <template v-else-if="nudgeConfig.showCta" #actions>
                        <MdButton data-qa-id="nudge-sign-agreement-btn" @click="handleNudgeCtaClick">
                            <MdIconAgreements icontitle="disabled" size="sm" slot="icon-start" />
                            {{ $t('components.general.side_nav_nudge.sign_latest_agreement') }}
                        </MdButton>
                    </template>
                </SideNavNudge>
                <site-navigation-footer v-if="isNavBarOpen || showHamIcon" />
            </div>
        </nav>
    </div>
</div>